import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import moment from 'moment';
import CardDocument from '../../../../components/Cards/Document';
import Modal from '../../../../components/Modal';
import FileViewer from '../../../../components/FileViewer';
import Button from '../../../../components/Button';
import StepProgress from '../../../../components/StepProgress';
import Icon from '../../../../components/Icons';

import dataDocs from './data';

import {
    salvarRascunho,
    inativar,
    salvarArquivo,
    buscarArquivo,
    removerArquivo,
    buscaDadosDependente,
    getListaValoresPlanos,
} from '../../../../services';

import DAP from '../../AdicionarBeneficiario/PDFs/DAP';

import steps from '../../../../utils/steps.json';
import { generatePdf } from '../../../../utils/generatePdf';
import { cloneObject, base64toBlob, handleTopCritics, addTimeToNameFile, checkIsSupport } from '../../../../utils';

import Alertas from '../Alertas';

import { useAposentadosDemitidos } from '../../../../contexts/AposentadosDemitidos/context';
import { useGlobal } from '../../../../contexts/Global/context';

import { PageContainer, ButtonSection, ContainerButton } from '../../../../styles/styles';

import * as S from './styles';
import PageLoader from '../../../../components/PageLoader';
import regexps from '../../../../utils/regexps';

function Documentos() {
    const history = useHistory();
    const { dataActiveContract, contrastTheme, setShowSupportModal } = useGlobal();

    const {
        dataBeneficiario,
        dataInputForm,
        dataDocuments,
        setDataDocuments,
        dataAposentadosDemitidos,
        setAlerts,
        dataMovimentacao,
        setDataMovimentacao,
    } = useAposentadosDemitidos();

    const [showModal, setShowModal] = useState(false);
    const [sendRequestLoading, setSendRequestLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [modalInfo, setModalInfo] = useState({});
    const [dataValoresPlanos, setDataValoresPlanos] = useState({});
    const [dependentesList, setDependentesList] = useState([]);

    function verificarSituacao() {
        if (dataAposentadosDemitidos.situacao === '2') return dataDocs.aposentadosDemitidosUpload;

        return dataDocs.aposentadosDemitidosUpload.filter((item) => item.id !== 15);
    }
    async function loadScreenData() {
        setPageLoading(true);

        const promises = dataBeneficiario.dependentes.map(async (dependente) => {
            const dataDependente = await buscaDadosDependente(dependente.numAssociado, dataActiveContract.numero);
            return dataDependente;
        });

        const dependentes = await Promise.all(promises);
        const titularExclusao = dataBeneficiario.dataExclusao.substring(0, 10);

        const activeDependents = dependentes.filter(
            (element) =>
                element.situacao !== 'EXCLUIDO' ||
                (element.situacao === 'EXCLUIDO' && element.dataExclusao.substring(0, 10) === titularExclusao)
        );

        setDependentesList(activeDependents);

        const listaValores = (await getListaValoresPlanos(
            dataActiveContract.numero,
            dataBeneficiario.planoSaude.codigo,
            {
                periodoNegociacao:
                    dataActiveContract.dataUltimaVigencia &&
                    moment(dataActiveContract.dataUltimaVigencia, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                situacaoBeneficiario: 'Inativo',
            }
        )) || [{}];

        const tipoMensalidade = listaValores[0]?.plano?.tipo;

        const formattedBirthday = moment(dataBeneficiario.dtNascimento, 'MM/DD/YYYY H:mm:ss').format('YYYY-MM-DD');

        const titularAge = moment().diff(formattedBirthday, 'years');

        let valorMensalTitular;
        let valorMensalidadeDependentes;

        if (tipoMensalidade === 'perCapta') {
            valorMensalTitular = listaValores[0].titular;

            valorMensalidadeDependentes = activeDependents.length * listaValores[0].dependente;
        } else {
            valorMensalTitular =
                listaValores?.find(({ faixaEtaria: faixa }) => {
                    const range = faixa.split('-');

                    return titularAge >= +range[0] && titularAge <= +range[1];
                })?.titular || 0;

            const mensalidades = activeDependents.map((dependente) => {
                const formattedBirthdayDependent = moment(dependente.dtNascimento, 'MM/DD/YYYY H:mm:ss').format(
                    'YYYY-MM-DD'
                );

                const dependentAge = moment().diff(formattedBirthdayDependent, 'years');

                const valorMensalDependente =
                    listaValores?.find(({ faixaEtaria: faixa }) => {
                        const range = faixa.split('-');

                        return dependentAge >= +range[0] && dependentAge <= +range[1];
                    }) || {};

                return valorMensalDependente?.dependente || 0;
            });

            valorMensalidadeDependentes = mensalidades.reduce((acc, next) => acc + next, 0);
        }

        setDataValoresPlanos({
            lista: listaValores,
            tipoMensalidade,
            valorMensalTitular,
            valorMensalidadeDependentes,
        });

        setPageLoading(false);
    }

    useEffect(() => {
        if (!dataAposentadosDemitidos.situacao) {
            history.push('/movimentacao_cadastral/selecionar_aposentados_demitidos');
        }

        loadScreenData();

        if (dataAposentadosDemitidos.situacao !== '2') {
            setDataDocuments([...dataDocuments.filter((item) => item.id !== 15)]);
        }
    }, []);

    function disableBtn() {
        if (sendRequestLoading) {
            return true;
        }

        // eslint-disable-next-line arrow-body-style
        const disableds = verificarSituacao().map((docId) => {
            return dataDocuments.some((elem) => elem.id === docId.id);
        });

        return disableds.some((elem) => elem === false);
    }

    async function handleShowModal(file) {
        const payloadFile = {
            cpfCnpj: dataBeneficiario.cpf,
            numeroContrato: dataActiveContract.numero,
            tipoArquivo: file.id,
            nomeArquivo: file.name,
        };

        const responseDoc = await buscarArquivo(payloadFile);
        const documento = responseDoc[0];

        const mode = ['jpeg', 'jpg', 'png', 'svg'].includes(documento.extArquivo.toLowerCase())
            ? 'image'
            : 'application';

        const blob = base64toBlob(documento.base64, `${mode}/${documento.extArquivo}`);
        const blobUrl = URL.createObjectURL(blob);

        setModalInfo({
            title: file.name,
            content: <FileViewer fileExtension={documento.extArquivo} src={blobUrl} base64={documento.base64} />,
        });

        setShowModal(true);
    }

    function handleFileChange({ event, id }) {
        if (!event.target.files) return;
        setPageLoading(true);

        const file = event.target.files[0];
        const { name: fileName, size: fileSize } = file;

        const fileNameFiltered = fileName.replace(regexps.charRemove, '');
        event.target.value = null;

        const acceptedFormats = ['jpeg', 'jpg', 'png', 'pdf', 'svg'];

        const fileExtention = fileNameFiltered.substring(fileNameFiltered.lastIndexOf('.') + 1);
        if (!acceptedFormats.includes(fileExtention.toLowerCase())) return;

        const fileSizeKb = fileSize / 1024;

        if (fileSizeKb > 25000) {
            setPageLoading(false);
            const modalContent = 'Somente é permitido anexar documentos com tamanho inferior a 25000KB (25MB).';
            setModalInfo({
                title: 'Erro',
                content: <p>{modalContent}</p>,
                backButton: true,
            });

            setShowModal(true);
            return;
        }

        const dataDocument = {
            id,
            name: addTimeToNameFile(fileNameFiltered, fileExtention),
            size: `${fileSizeKb.toFixed(2)}Kb`,
        };

        const documents = cloneObject(dataDocuments);

        const foundDocument = documents.filter((document) => document.id === id && document.name === fileNameFiltered);

        if (foundDocument.length) return;

        documents.push(dataDocument);

        setDataDocuments([...documents]);

        const reader = new FileReader();

        reader.onloadend = async () => {
            const documentsList = dataDocs.aposentadosDemitidosUpload;

            const dataDoc = documentsList.find((document) => document.id === id);

            const payloadDocument = {
                cpfCnpj: dataBeneficiario.cpf,
                numeroContrato: dataActiveContract.numero,
                tipoArquivo: dataDocument.id,
                nomeArquivo: dataDocument.name,
                extArquivo: fileExtention,
                descArquivo: dataDoc?.label || 'Outros',
                base64: reader.result.split(',')[1],
            };
            const doc64 = [];
            doc64.push(payloadDocument);
            await salvarArquivo(payloadDocument);
            setPageLoading(false);
        };

        reader.readAsDataURL(file);
    }

    function handleFileDelete({ id, fileName }) {
        let documents = cloneObject(dataDocuments);

        documents = documents.filter((document) => document.name !== fileName);
        setDataDocuments([...documents]);

        const payload = {
            cpfCnpj: dataBeneficiario.cpf,
            numeroContrato: dataActiveContract.numero,
            tipoArquivo: id,
            nomeArquivo: fileName,
        };

        removerArquivo(payload);
    }

    async function handleSaveDraft() {
        const rascunhoStatus = await salvarRascunho({
            cpfCnpj: dataBeneficiario.cpf,
            numeroContrato: dataActiveContract.numero,
            rascunho: {
                flow: 'aposentados_demitidos',
                dataHora: new Date().toISOString(),
                dataActiveContract,
                dataInputForm,
                dataDocuments,
                dataBeneficiario,
            },
        });

        if (rascunhoStatus === 200) {
            history.push({
                pathname: '/movimentacao_cadastral/salvar_rascunho_aposentados_demitidos',
            });
        } else {
            let modalContent = 'Erro ao salvar rascunho. Tente novamente.';
            if (rascunhoStatus === 409) modalContent = 'Já existe rascunho salvo para este CPF/Contrato.';

            setModalInfo({
                title: 'Erro',
                content: <p>{modalContent}</p>,
                backButton: true,
            });

            setShowModal(true);
        }
    }

    async function handleFowardStep() {
        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        setSendRequestLoading(true);
        setPageLoading(true);

        const documentsAPIRequests = dataDocuments.map(async (doc) => {
            const { id: tipoArquivo, name: nomeArquivo } = doc;

            return buscarArquivo({
                cpfCnpj: dataBeneficiario.cpf,
                numeroContrato: dataActiveContract.numero,
                tipoArquivo,
                nomeArquivo,
            });
        });

        const documentsAPIResponse = await Promise.all(documentsAPIRequests);

        const payloadDocuments = documentsAPIResponse.flat().map((doc) => ({
            NomeArquivo: doc.nomeArquivo,
            Base64Arquivo: doc.base64,
        }));

        // const documentsAPI = await buscarArquivo({
        //     cpfCnpj: dataBeneficiario.cpf,
        //     numeroContrato: dataActiveContract.numero,
        // });

        // const filteredDocs = documentsAPI
        //     .filter((doc) =>
        //         dataDocuments.find(
        //             (uploadedDoc) => uploadedDoc.id === doc.tipoArquivo && uploadedDoc.name === doc.nomeArquivo
        //         )
        //     )
        //     .map(({ nomeArquivo, base64 }) => ({ NomeArquivo: nomeArquivo, Base64Arquivo: base64 }));

        const payload = {
            ...dataAposentadosDemitidos,
            ...dataMovimentacao,
            anexos: dataMovimentacao.sequencialMovimentacao ? [] : payloadDocuments,
            referenciaMovimentacao: dataActiveContract.referenciaMovimentacao?.dataReferenciaMovimentacao,
        };

        const response = await inativar(payload);

        if (response.errorDescription) {
            response.movimentacoes = [
                {
                    criticas: [
                        {
                            tipo: 1,
                            descricao: response.errorDescription,
                            codigo: '#DEFAULT_ERROR',
                        },
                    ],
                },
            ];
        }

        const movimentacao = response.movimentacoes[0];
        const criticas = handleTopCritics(movimentacao.criticas);

        setDataMovimentacao({
            sequencialMovimentacao: movimentacao.sequencialMovimentacao,
            codigoSituacaoMovimentacao: movimentacao.codigoSituacaoMovimentacao,
            tipoAcao: 2,
        });

        if (criticas.length > 0) {
            setAlerts([...criticas]);

            setTimeout(() => {
                window.document.getElementById('page-content').scrollTo(0, 0);
            }, 100);

            setSendRequestLoading(false);
            setPageLoading(false);

            return;
        }

        history.push('/movimentacao_cadastral/aguardar_analise_aposentados_demitidos');
    }

    return (
        <PageContainer>
            <StepProgress steps={steps.aposentadosDemitidos} activeStep={3} />

            <Alertas />

            <S.PageTitle>1 - Faça o download do termo DAP abaixo e assine juntamente com o beneficiário.</S.PageTitle>

            <S.ContainerDownload>
                <Icon name="description" color={contrastTheme ? '#FFFFFF' : '#5B5B5F'} size={30} />
                <S.SpacingCard>
                    <S.Title>Termo DAP para download</S.Title>
                    <S.BtnDownload
                        onClick={() => {
                            generatePdf(
                                <DAP
                                    form={{ ...dataBeneficiario, ...dataInputForm }}
                                    valores={dataValoresPlanos}
                                    dependentesList={dependentesList}
                                />,
                                `Termo DAP_${dataActiveContract.numero}_${moment().format('DD_MM_YYYY')}`
                            );
                        }}
                    >
                        Baixar
                    </S.BtnDownload>
                </S.SpacingCard>
            </S.ContainerDownload>

            <S.PageTitle>2 - Agora, faça o upload dos outros documentos necessários para análise.</S.PageTitle>
            <div>
                {verificarSituacao()?.map((doc) => {
                    const files = dataDocuments.filter((document) => document.id === doc.id);

                    return (
                        <CardDocument
                            id={doc.id}
                            name={doc.label}
                            label={false}
                            files={files}
                            onFileChange={(event) => handleFileChange({ event, id: doc.id, size: doc.size })}
                            onDeleteFile={handleFileDelete}
                            onClickViewFile={(dataFileClicked) =>
                                handleShowModal({
                                    hasFiles: !!dataDocuments,
                                    cpf: dataBeneficiario.cpf,
                                    ...dataFileClicked,
                                })
                            }
                        />
                    );
                })}
            </div>

            <ButtonSection>
                <Button id="backStep" type="secondary" onClick={handleSaveDraft}>
                    Salvar rascunho
                </Button>
                <ContainerButton>
                    <Button
                        id="backStep"
                        type="secondary"
                        onClick={() => history.push('/movimentacao_cadastral/preencher_dados_aposentados_demitidos')}
                    >
                        Editar formulário
                    </Button>

                    <Button id="continueStep" type="primary" onClick={handleFowardStep} disabled={disableBtn()}>
                        Continuar
                    </Button>
                </ContainerButton>
            </ButtonSection>
            <Modal
                title={modalInfo.title}
                modalSize="lg"
                subtitle={modalInfo.content}
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                {modalInfo.backButton && (
                    <Button type="primary" onClick={() => setShowModal(false)}>
                        Voltar
                    </Button>
                )}
            </Modal>

            <PageLoader loading={pageLoading} />
        </PageContainer>
    );
}

export default Documentos;
